'use client';

import React from 'react';
import ServerItem from './ServerItem';
import { Loader2 } from 'lucide-react';
import { useDashboard } from '../DashboardContext';
import { Separator } from '@/components/ui/separator';

interface ServerListProps {
  preserveDrawer?: boolean;
}

const ServerList: React.FC<ServerListProps> = ({ preserveDrawer = false }) => {
  const { guilds, isLoadingGuilds, currentGuildId, selectGuild } = useDashboard();

  if (isLoadingGuilds) {
    return (
      <div className="flex justify-center items-center w-full p-2">
        <Loader2 className="h-5 w-5 animate-spin text-primary" />
      </div>
    );
  }

  // has_kamibot이 true인 서버를 먼저 정렬합니다
  // 그 중에서도 owner가 true인 서버를 최상위로 정렬합니다
  // 같은 조건일 경우 멤버 수가 높은 서버를 우선시합니다
  const sortedGuilds = [...guilds].sort((a, b) => {
    // has_kamibot이 둘 다 true인 경우, owner 여부로 정렬
    if (a.has_kamibot && b.has_kamibot) {
      if (a.owner && !b.owner) return -1;
      if (!a.owner && b.owner) return 1;
      
      // owner 여부가 같은 경우 멤버 수로 정렬
      return b.members_count - a.members_count;
    }
    
    // has_kamibot 여부로 정렬
    if (a.has_kamibot && !b.has_kamibot) return -1;
    if (!a.has_kamibot && b.has_kamibot) return 1;
    
    // 둘 다 카미봇이 없는 경우 멤버 수로 정렬
    return b.members_count - a.members_count;
  });

  return (
    <div className="flex flex-col items-center w-full">
      <Separator className="w-4/5 mb-2" />
      {/* 기존 서버 목록 */}
      {sortedGuilds.map((guild) => (
        <ServerItem
          key={guild.id}
          guild={guild}
          isSelected={guild.id === currentGuildId}
          onClick={() => selectGuild(guild.id)}
          preserveDrawer={preserveDrawer}
        />
      ))}
    </div>
  );
};

export default ServerList;
